/**
 * ============================================================================
 * BAMBOOVE — HOẠT ẢNH MỞ/ĐÓNG cho MENU ACCORDION ở FOOTER (07/10/2026 · phiên 40)
 * ----------------------------------------------------------------------------
 * Bamboove mở/đóng <details> TỨC THÌ (transition 0s) ⇒ nhìn như "giật".
 * Nay tự chạy hoạt ảnh `height` cho êm (mở VÀ đóng):
 *   • MỞ  : open=true → height 0 → ép reflow → height = scrollHeight px
 *   • ĐÓNG: height = scrollHeight px → ép reflow → height 0 → xong mới open=false
 *   • Xong: gỡ height (về auto) ⇒ không kẹt chiều cao khi đổi khổ màn hình
 * ⚠️ VÌ SAO KHÔNG dùng `grid-template-rows 0fr→1fr`? ĐO RỒI (Chromium 153): không nội
 *    suy, nhảy 1 nhịp. Còn `height` px thì mượt mọi trình duyệt.
 * ⚠️ 300ms PHẢI khớp `.bb-ft-chay` trong assets/bamboove-footer.css.
 * ============================================================================
 */
(function () {
  'use strict';
  var MOC = '.menu--accordion .menu__details';
  var CHAY = 'bb-ft-chay';
  var MS = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 0 : 300;

  function than(d) { return d.querySelector('.details-content'); }

  /* Khớp Bamboove: "màn hình rộng" = >= 750px (assets/utilities.js: mediaQueryLarge).
     Khối menu ở footer đặt disable_on_desktop=true ⇒ ở khổ >=750px Bamboove VÔ HIỆU accordion
     (menu hiện đủ, không đóng/mở). JS của ta phải theo y hệt, nếu không sẽ tự đóng menu ở máy tính. */
  function biChan(d) {
    var rong = window.innerWidth >= 750;
    if (!rong && d.closest('[data-disable-on-mobile="true"]')) return true;
    if (rong && d.closest('[data-disable-on-desktop="true"]')) return true;
    return false;
  }


  /* Xong hoạt ảnh: gỡ lớp transition + trả height về auto, rồi mới chốt trạng thái open */
  function xong(d, c, laMo) {
    clearTimeout(d._bbFtT);
    d._bbFtT = setTimeout(function () {
      c.classList.remove(CHAY);
      c.style.height = '';
      d.open = laMo;
      d._bbFtDang = 0;
    }, MS + 40);
  }

  function mo(d, c) {
    d._bbFtDang = 1;
    d.open = true;              /* cho nội dung hiện ra để đo */
    c.classList.remove(CHAY);
    c.style.height = '0px';
    void c.offsetHeight;        /* ép trình duyệt "chốt" mốc 0 */
    c.classList.add(CHAY);
    c.style.height = c.scrollHeight + 'px';
    xong(d, c, true);
  }

  function dong(d, c) {
    d._bbFtDang = 1;
    c.classList.remove(CHAY);
    c.style.height = c.scrollHeight + 'px';
    void c.offsetHeight;        /* ép trình duyệt "chốt" mốc cao hiện tại */
    c.classList.add(CHAY);
    c.style.height = '0px';
    xong(d, c, false);
  }

  function gan() {
    document.querySelectorAll(MOC).forEach(function (d) {
      if (d.dataset.bbFt === '1') return;
      d.dataset.bbFt = '1';
      var s = d.querySelector('summary');
      var c = than(d);
      if (!s || !c) return;
      s.addEventListener('click', function (e) {
        if (biChan(d)) return;                   /* khổ này Bamboove vô hiệu accordion ⇒ để yên */
        e.preventDefault();                      /* tự quyết định mở/đóng để hoạt ảnh chạy đủ */
        /* (07/10/2026 · p44) BẤM LẶP = KHÔNG LÀM GÌ — theo ĐÚNG cơ chế Nike
           (soi tại _DO\_soi-nike-click.txt). Khi Nike ĐANG ĐÓNG mà khách bấm tiếp, nó chỉ chạy
           `closing = true` lần nữa; vì giá trị đã là true nên React KHÔNG dựng lại ⇒ hoạt ảnh
           đang chạy KHÔNG bị khởi động lại ⇒ KHÔNG giật. Tức: MỖI LÚC CHỈ NHẬN 1 LỆNH.
           Bản CŨ thì ngược lại: bấm lặp ⇒ clearTimeout + xoá `height` ⇒ nội dung BẬT về hết cỡ
           (nhảy) rồi mới chạy lại ⇒ đúng cái "giật + lỗi" khách báo. */
        if (d._bbFtDang) return;                 /* đang chạy hoạt ảnh ⇒ bỏ qua lệnh mới (mỗi lúc 1 lệnh) */
        if (d.open) dong(d, c);
        else mo(d, c);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gan);
  else gan();
  document.addEventListener('shopify:section:load', gan);
})();
